import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let kejianrouter = new Router({
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("./views/Home.vue"),
        },
        {
            path: "/news",
            name: "news",
            component: () => import("./views/News.vue"),
        },
        {
            path: "/newsdetails/:id",
            name: "newsdetails",
            component: () => import("./views/NewsDetails.vue"),
        },
        {
            path: "/product",
            name: "product",
            component: () => import("./views/Product.vue"),
        },
        {
            path: "/case",
            name: "case",
            component: () => import("./views/Case.vue"),
        },
        {
            path: "/casedetails/:id",
            name: "casedetails",
            component: () => import("./views/CaseDetails.vue"),
        },
        {
            path: "/goin",
            name: "goin",
            component: () => import("./views/GoIn.vue"),
        },
        {
            path: "/download",
            name: "download",
            component: () => import("./views/Download.vue"),
        },
    ],
});

export default kejianrouter;
